<div class="sidebar-header">{{headerContent}}</div>
<form class="standard-form" (ngSubmit)="onSubmit()" [formGroup]="strategyForm">
  <label class="standard-label" for="strategyName">Name</label>
  <div class="input-error-wrap sans-margin">
    <input auto="name-field" class="standard-input block" type="text" id="strategyName" placeholder="Name of plan" name="strategy name" [formControl]="name" [maxlength]="MAX_NAME_LENGTH">
    <div class="remaining-msg">Remaining: {{ remainingCharacters }}</div>
    <app-error-msg [control]="name" [show]="showStrategyNameErrors"></app-error-msg>
  </div>
  <div class="input-error-wrap">
    <app-error-msg [control]="endDate" [show]="showDateErrors"></app-error-msg>
    <label class="standard-label">Select Target Dates</label>
    <div class="flex-date-row">
        <p-calendar styleClass="strategies-calendar" inputStyleClass="standard-input" [formControl]="startDate" placeholder="Start Date" [(ngModel)]="startDateValue" [showIcon]="true">
        </p-calendar>
        <p-calendar styleClass="strategies-calendar" inputStyleClass="standard-input" [formControl]="endDate" placeholder="End Date" [(ngModel)]="endDateValue" [showIcon]="true"
                    [minDate]="startDate.value">
        </p-calendar>
    </div>
  </div>
  <div class="button-row">
    <button auto="cancel-btn" class="btn btn-alt left-btn" type="button" (click)="cancel.emit()">Cancel</button>
    <button auto="save-btn" class="btn" type="submit" [disabled]="isSubmitDisabled">Save</button>
  </div>
</form>
